import { render } from "./FlagIcon.vue?vue&type=template&id=3d0a3548"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__